<template>
    <span>
        <kgr-generic-modal
            :value="value"
            :headline="headline"
            @post-input="onInput"
        >
            {{ $t('confirmDeleteMessage', { objectName }) }}
            <template #footer>
                <kgr-button
                    class="kgr-col"
                    @click="confirm()"
                >{{ $t('delete') }}</kgr-button>
                <kgr-button
                    type="grey"
                    @click="cancel()"
                >{{ $t('cancel') }}</kgr-button>
            </template>
        </kgr-generic-modal>
        <slot></slot>
    </span>
</template>

<script>
import Button from '../form/button/KgrButton';
import GenericModal from './GenericModal';

export default {
    components: {
        'kgr-generic-modal': GenericModal,
        'kgr-button': Button,
    },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        objectName: {
            type: String,
            required: true,
        },
    },
    computed: {
        headline() {
            return this.$t('delete');
        },
    },
    methods: {
        confirm() {
            this.$emit('confirm');
            this.$emit('input', false);
            this.$nextTick(() => {
                this.$emit('post-input', false);
            });
        },
        cancel() {
            this.$emit('input', false);
            this.$nextTick(() => {
                this.$emit('post-input', false);
            });
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
